import React, { useState } from 'react';

import {
  Typography,
  TextField,
  InputAdornment,
  Grid,
  Tooltip,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { formatMoney, stripMoney, stripPolicyNum } from '../../core/validate';

const PolicyInfo = (props) => {
  const { info, setInfo } = props;
  const [policyNumErr, setPolicyNumErr] = useState('');

  const changeInfo = (data) => {
    for (const key in data) {
      const val = data[key];

      if (info[key] !== val) {
        setInfo({ ...info, ...data });
        break;
      }
    }
  };

  const handlePolicy = (e) => {
    const val = stripPolicyNum(e.target.value);

    if (val.length > 6) setPolicyNumErr('Can not be longer than 6 digits');
    else if (!!policyNumErr) setPolicyNumErr('');

    changeInfo({ policy: val });
  };

  const handleAmount = (e) =>
    changeInfo({ amount: stripMoney(e.target.value) });

  const validatePolicy = (num) => {
    if (/\D/.test(num)) return 'Can only contain numbers';

    if (num.length !== 6) return 'Must be 6 digits';

    return false;
  };

  return (
    <div>
      <Typography gutterBottom={true}>
        Please enter the policy number and the amount you wish to pay
      </Typography>
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <TextField
            variant="outlined"
            color="primary"
            label="Policy Number"
            type="text"
            value={info.policy}
            onChange={handlePolicy}
            placeholder="123456"
            fullWidth
            error={!!policyNumErr}
            helperText={policyNumErr}
            onBlur={() => setPolicyNumErr(validatePolicy(info.policy))}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            variant="outlined"
            color="primary"
            label="Payment Amount"
            type="text"
            value={formatMoney(info.amount)}
            onChange={handleAmount}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};
export default PolicyInfo;
